import React from 'react'
import classnames from 'classnames'
import SymbolSvg from 'assets/img/logo/symbol.svg'
import TextSvg from 'assets/img/logo/text.svg'
import style from './style.module.scss'

const SuperEgoLogo = ({ collapsed, className }) => {
  return (
    <div className={classnames(style.logo, { [style.collapsed]: collapsed }, className)}>
      <img className={style.symbol} src={SymbolSvg} alt="" />
      <img className={style.text} src={TextSvg} alt="" />
    </div>
  )
}

export default SuperEgoLogo
